export type SupportedLocale = 'de' | 'en';
export const SUPPORTED_LOCALES: ReadonlyArray<SupportedLocale> = ['de', 'en'];

export function resolveLocale(input: string | null | undefined): SupportedLocale {
  if (!input) return 'en';
  const head = input.toLowerCase().split('-')[0];
  return (SUPPORTED_LOCALES as ReadonlyArray<string>).includes(head)
    ? (head as SupportedLocale)
    : 'en';
}
